import React from 'react'
import {molabsStyles} from "../styles";
import Page from "../components/page";
import Teaser from "../components/home/Teaser";
import {useIntl} from "react-intl";

function Home() {
    const classes = molabsStyles();
    const intl = useIntl();
    const image = require('../images/hero4.jpg?resize&sizes[]=1216&sizes[]=960&sizes[]=600&sizes[]=200');
    const webp = require('../images/hero4.jpg?resize&sizes[]=1216&sizes[]=960&sizes[]=600&sizes[]=200&format=webp');

    return (
        <Page
            image={image}
            webp={webp}
            title={intl.formatMessage({id: 'home_title'})}
            description={intl.formatMessage({id: 'home_desc'})}
            metaTitle={intl.formatMessage({id: 'home_title'})}>
            <div className={classes.contentContainer}>
                <Teaser
                    image={require("../images/home-teaser1.jpg?size=260")}
                    headline={intl.formatMessage({id: 'home_teaser1_headline'})}
                    description={intl.formatMessage({id: 'home_teaser1_desc'})}
                    ctaLabel={intl.formatMessage({id: 'contactUs'})}
                    ctaUrl="/contact"
                />
                <Teaser
                    image={require("../images/home-teaser3.jpg?size=260")}
                    headline={intl.formatMessage({id: 'home_teaser3_headline'})}
                    description={intl.formatMessage({id: 'home_teaser3_desc'})}
                    ctaLabel={intl.formatMessage({id: 'contactUs'})}
                    ctaUrl="/contact"
                />
                <Teaser
                    image={require("../images/home-teaser2.jpg?size=260")}
                    headline={intl.formatMessage({id: 'home_teaser2_headline'})}
                    description={intl.formatMessage({id: 'home_teaser2_desc'})}
                    ctaLabel={intl.formatMessage({id: 'contactUs'})}
                    ctaUrl="/contact"
                />
                <Teaser
                    image={require("../images/home-teaser4.jpg?size=260")}
                    headline={intl.formatMessage({id: 'home_teaser4_headline'})}
                    description={intl.formatMessage({id: 'home_teaser4_desc'})}
                    ctaLabel={intl.formatMessage({id: 'contactUs'})}
                    ctaUrl="/contact"
                />
            </div>
        </Page>
    );
}

export default Home;
